import * as Sentry from "@sentry/react-router"
import i18next from "i18next"
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector"
import Fetch from "i18next-fetch-backend"
import {StrictMode, startTransition} from "react"
import {hydrateRoot} from "react-dom/client"
import {I18nextProvider, initReactI18next} from "react-i18next"
import {HydratedRouter} from "react-router/dom"

import {logAndReportError} from "~/lib/util/logAndReportError"

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://dbe75a33bd25d5bfb24d30bfef84bad7@o4509033858793472.ingest.de.sentry.io/4509038733099088",
    environment: process.env.SENTRY_ENVIRONMENT,
    integrations: [Sentry.reactRouterTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^\//],
  })
}

const main = async () => {
  await i18next
    .use(initReactI18next)
    .use(Fetch)
    .use(I18nextBrowserLanguageDetector)
    .init({
      fallbackLng: "en",
      detection: {order: ["htmlTag"], caches: []},
      backend: {loadPath: "/api/locales/{{lng}}/{{ns}}"},
      preload: ["en", "es"],
    })

  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <StrictMode>
          <HydratedRouter />
        </StrictMode>
      </I18nextProvider>,
    )
  })
}

main().catch((error) => logAndReportError(error))
